import { Link } from 'react-router-dom';
import { FiMail, FiPhone, FiMapPin } from 'react-icons/fi';
import { FaFacebookF, FaXTwitter, FaLinkedinIn } from 'react-icons/fa6';
import './Footer.css';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="footer">
      <div className="footer-container">
        <div className="footer-grid">
          {/* Brand */}
          <div className="footer-brand">
            <Link to="/" className="footer-logo">
              <img src="/logo192.png" alt="MediGoMap" className="footer-logo-img" />
              <span className="footer-logo-text">
                Medi<span className="footer-logo-accent">Go</span>Map
              </span>
            </Link>
            <p className="footer-tagline">
              Find trusted healthcare providers near you. From hospitals and clinics to specialists and alternative medicine.
            </p>
            <div className="footer-company">
              <p>Public Health Solution LLC</p>
              <p>2003 Plank Road, #1283</p>
              <p>Fredericksburg, VA 22401</p>
            </div>
            <div className="footer-social">
              <a href="https://www.facebook.com/medigomap" target="_blank" rel="noopener noreferrer" aria-label="Facebook">
                <FaFacebookF />
              </a>
              <a href="https://x.com/medigomap" target="_blank" rel="noopener noreferrer" aria-label="X (Twitter)">
                <FaXTwitter />
              </a>
              <a href="https://www.linkedin.com/company/medigomap" target="_blank" rel="noopener noreferrer" aria-label="LinkedIn">
                <FaLinkedinIn />
              </a>
            </div>
          </div>

          {/* Quick Links */}
          <div className="footer-section">
            <h4 className="footer-heading">Quick Links</h4>
            <ul className="footer-links">
              <li><Link to="/">Home</Link></li>
              <li><Link to="/how-it-works">How It Works</Link></li>
              <li><Link to="/blog">Blog</Link></li>
              <li><Link to="/faq">FAQs</Link></li>
              <li><Link to="/insurance">Health Insurance</Link></li>
              <li><Link to="/advertise">Advertise</Link></li>
              <li><Link to="/about">About Us</Link></li>
            </ul>
          </div>

          {/* Legal */}
          <div className="footer-section">
            <h4 className="footer-heading">Legal</h4>
            <ul className="footer-links">
              <li><Link to="/privacy">Privacy Policy</Link></li>
              <li><Link to="/terms">Terms of Service</Link></li>
              <li><Link to="/cookies">Cookie Policy</Link></li>
              <li><Link to="/contact">Contact Us</Link></li>
            </ul>
          </div>

          {/* Contact */}
          <div className="footer-section">
            <h4 className="footer-heading">Contact</h4>
            <ul className="footer-contact">
              <li>
                <FiMail className="footer-contact-icon" />
                <a href="mailto:support@medigomap.com">support@medigomap.com</a>
              </li>
              <li>
                <FiPhone className="footer-contact-icon" />
                <span>(540) 322-7406 (Text only)</span>
              </li>
              <li>
                <FiMapPin className="footer-contact-icon" />
                <span>2003 Plank Road, #1283, Fredericksburg, VA 22401</span>
              </li>
            </ul>
          </div>
        </div>

        <div className="footer-bottom">
          <p>&copy; {currentYear} MediGoMap — Public Health Solution LLC. All rights reserved.</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
